import { Box } from '@material-ui/core'

// ----------------------------------------------------------------------

// The product name as it should read in UI copy: "Genesus" with a superscript TM.
// Inherits font, size and colour from the surrounding text.
export default function GenesusName() {
  return (
    <>
      Genesus
      <Box
        component="sup"
        sx={{ fontSize: '0.5em', fontWeight: 400, lineHeight: 0, ml: '0.1em', verticalAlign: 'super' }}
      >
        TM
      </Box>
    </>
  )
}
